import React from 'react';
import { MenuIcon } from 'lucide-react';
export function Navbar() {
  return <header className="w-full bg-white shadow-sm fixed top-0 left-0 right-0 z-50" data-id="element-110">
      <div className="container mx-auto px-4 py-4 flex justify-between items-center" data-id="element-111">
        <div className="flex items-center" data-id="element-112">
          <h1 className="text-2xl font-bold text-blue-600" data-id="element-113">Super Neil </h1>
        </div>
        <nav className="hidden md:flex space-x-8" data-id="element-114">
          <a href="#benefits" className="text-gray-600 hover:text-blue-600 font-medium" data-id="element-115">
            Benefits
          </a>
          <a href="#process" className="text-gray-600 hover:text-blue-600 font-medium" data-id="element-116">
            Process
          </a>
          <a href="#pricing" className="text-gray-600 hover:text-blue-600 font-medium" data-id="element-117">
            Pricing
          </a>
          <a href="#faq" className="text-gray-600 hover:text-blue-600 font-medium" data-id="element-118">
            FAQ
          </a>
        </nav>
        <div className="md:hidden" data-id="element-119">
          <button className="text-gray-600" data-id="element-120">
            <MenuIcon size={24} data-id="element-121" />
          </button>
        </div>
        <a href="#pricing" className="hidden md:block bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-md font-medium transition-colors" data-id="element-122">
          Get Your ITIN
        </a>
      </div>
    </header>;
}